import { useMemo } from 'react';
import { useBrand } from '../contexts/BrandContext';
import {
  documentMetaFromBrand,
  useDocumentMeta,
} from '../hooks/useDocumentMeta';

export default function BrandDocumentHead() {
  const brand = useBrand();
  const meta = useMemo(() => documentMetaFromBrand(brand), [brand]);
  useDocumentMeta(meta);
  return null;
}
